import React from "react";

import { Text } from "@/components/Text";
import { IConsultantProfile } from "@/data/consultant-profiles";
import { formatFullName } from "@/data/persons";
import { Avatar } from "@/views/components/Person/Avatar";

import "./_context-switcher-logo-section.scss";

interface IConsultantContextSwitcherAvatarProps {
  consultant: IConsultantProfile;
}

export const ConsultantContextSwitcherAvatar: React.FC<IConsultantContextSwitcherAvatarProps> = React.memo(
  ({ consultant }) => {
    return (
      <>
        <Avatar
          size="xl"
          firstName={consultant.firstName}
          lastName={consultant.lastName}
          avatar={consultant.avatar}
          round={false}
          hjSuppress
        />
        <Text size="lg" weight="bold">
          {formatFullName(consultant)}
        </Text>
      </>
    );
  },
);
